module.exports = __webpack_public_path__ + "img/1440.ced7f2ea.jpg";